.related-links-type-1__tags-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--spacing-lg);
  margin-top: calc(var(--spacing-6xl) - var(--spacing-xs));
  margin-bottom: calc(-1 * var(--spacing-xs));

  @media (width <= 768px) {
    grid-template-columns: 1fr;
  }
}

.related-links-type-1__tags-list-item {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
